<div class="row">
  <div class="col-lg-6 order-lg-0 order-1">
    <div class="info-container">

      <div [innerHTML]="'Documents.Id.Help.BiometricTitle' | translate | safe:'html'" class="title">
      </div>

      <img alt="biometric example back" src="/img/biometric-example-back.png">
      <img alt="biometric example front" src="/img/biometric-example-front.png">

    </div>

  </div>
  <div class="col-lg-6 order-lg-1 order-0">
    <div class="info-container h-100">

      <div [innerHTML]="'Documents.Id.Help.NonBiometricTitle' | translate | safe:'html'" class="title">
      </div>

      <img alt="non biometric example" src="/img/non-biometric-example.png">

    </div>

  </div>
</div>

<div class="info-container">

  <ul>
    <li [innerHTML]="'Documents.Id.Help.File' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.Id.Help.Valid' | translate | safe:'html'"></li>
    <li [innerHTML]="'Documents.Id.Help.Filled' | translate | safe:'html'"></li>
  </ul>

</div>
